/**
 * BookingRecurrenceService — Phase 7a
 *
 * Recurring booking templates. List / create / cancel. Series occurrences
 * materialise into the Booking table via the BookingNotifications worker.
 *
 * Route: api/booking-recurrences
 */
import { BaseService } from '../base';
export class BookingRecurrenceService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingRecurrenceService.DEFAULT_SERVICE_PATH,
            basePath: BookingRecurrenceService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async list() {
        const response = await this.listRaw();
        return response.data ?? [];
    }
    listRaw() {
        return this.http.get(this.buildUrl());
    }
    async create(payload) {
        const response = await this.createRaw(payload);
        return response.data ?? null;
    }
    createRaw(payload) {
        return this.http.post(this.buildUrl(), payload);
    }
    async cancel(recurrenceId) {
        const response = await this.cancelRaw(recurrenceId);
        return response.data === true;
    }
    cancelRaw(recurrenceId) {
        return this.http.put(this.buildUrl(`${recurrenceId}/cancel`), {});
    }
}
BookingRecurrenceService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingRecurrenceService.BASE_PATH = 'api/booking-recurrences';
//# sourceMappingURL=BookingRecurrenceService.js.map